import marketplacePropertiesService from '../../services/MarketplacePropertiesService';
import multimediaService from '../../services/MultimediaService';
import questionHelperServices from '../../services/questionView/QuestionHelperServices';
import settingsReader from '../../store/readHelpers/SettingsReader';

const descriptionDocumentSelector = {
    selectDisableApproveButton(documentModel, hasAtLeastOneCompletelyPlayedMedia) {
        const hasOneMediaModel = documentModel?.mediaModels?.length === 1;
        if (!hasOneMediaModel) {
            return false;
        }

        const mediaModel = documentModel.mediaModels[0];

        return settingsReader.shouldCacheResourcesBeforeTestStart()
            && marketplacePropertiesService.isTestInformationVideoDependencyEnabled()
            && multimediaService.isVideoType(mediaModel)
            && multimediaService.canPlayOnlyOnce(mediaModel)
            && !hasAtLeastOneCompletelyPlayedMedia;
    },

    selectProps(state, ownProps) {
        const {
            test,
            navigationLock,
        } = ownProps;

        const {
            requiresDescriptionDocumentApproval,
            descriptionDocumentApproved,
            documentModel,
            hasAtLeastOneCompletelyPlayedMedia,
        } = test;

        const initialShowDescriptionDocument = requiresDescriptionDocumentApproval ? !descriptionDocumentApproved : true;

        return {
            descriptionDocumentApproved: !!descriptionDocumentApproved,
            disableApproveButton: this.selectDisableApproveButton(documentModel, hasAtLeastOneCompletelyPlayedMedia),
            documentModel,
            initialShowDescriptionDocument,
            lockDescriptionToggleButton: navigationLock.isLocked,
            requiresDescriptionDocumentApproval,
            services: questionHelperServices.getServices(),
            showApproveButton: requiresDescriptionDocumentApproval && !descriptionDocumentApproved,
        };
    },
};

export default descriptionDocumentSelector;
